import { memo, useMemo } from 'react'
import useAppData from 'app/services/hooks/useAppData'
import Loading from 'components/interface/Loading/Loading'
import useDelayedActiveState from 'lib/react/hooks/useDelayedActiveState'
import classNames from 'lib/util/classNames'
import styles from './Loader.module.scss'

/**
 * The `Loader`
 *
 * @returns {React.ReactElement} the react element
 */
function Loader () {
  const appData = useAppData()
  const isRender = useDelayedActiveState(!appData, 0, 0.25)
  const isVisible = useDelayedActiveState(!appData, 0, 0)
  const classNameOutput = useMemo(
    () => classNames([styles.loader]),
    [isVisible]
  )

  if (!isRender) {
    return null
  }

  return (
    <div className={classNameOutput}>
      <Loading />
    </div>
  )
}

// Memoize
export default memo(Loader)
